module.exports = __webpack_public_path__ + "static/Ginger@2x.18c398a8.png";